import { Component }        from '@angular/core';
import { NgForm }           from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { UIRouter }         from '@uirouter/core';

import { MessagesService }  from '../../app-lite/messages/messages.service';
import { PasswordsService } from './passwords.service';

@Component({
  selector   : 'request-password-reset',
  template: require('./password.request-reset.component.html')
})
export class RequestPasswordResetComponent {
  email: string;

  constructor (
    private messagesService : MessagesService,
    private passwordsService: PasswordsService,
    private router          : UIRouter,
    private translateService: TranslateService
  ) {}

  submit ( form : NgForm ) : void {
    this.passwordsService.requestReset(this.email)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.EMAIL_HAS_BEEN_SENT'), 'success');

      form.reset();

      this.router.stateService.go('app.login');
    })
    .catch(error => this.messagesService.error(error));
  }
}
